import styled, { css } from 'styled-components';

import { media } from '@/utils/mixin';

export const Component = styled.div`
  position: relative;
  padding-top: 38.703%;

  ${media.tablet(css`
    padding-top: initial;
  `)}
`;

export const ImageGrey = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  user-select: none;
  object-fit: contain;

  ${media.tablet(css`
    position: initial;
    inset: initial;
  `)}
`;

export const ImageBlue = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  pointer-events: none;
  user-select: none;

  clip-path: polygon(0 0, var(--value, 0) 0, var(--value, 0) 100%, 0% 100%);
  object-fit: contain;
`;

export const ImageOrange = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  pointer-events: none;
  user-select: none;

  clip-path: polygon(0 0, var(--min, 0) 0, var(--min, 0) 100%, 0% 100%);
  object-fit: contain;
`;
